/* eslint-disable no-restricted-globals */
import { useState, useRef, useEffect } from "react";
import { formatDateYYYYMMDD, last7Days } from "../../../helpers";

const DateRangeInputLogic = ({ startDate, endDate }) => {
  const getDateFormat = () => {
    return {
      startDate:
        startDate !== null ? formatDateYYYYMMDD(startDate) : last7Days()?.[0],
      endDate:
        endDate !== null ? formatDateYYYYMMDD(endDate) : last7Days()?.[1],
      key: "selection",
    };
  };
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef(null);
  const [dateRange, setDateRange] = useState(getDateFormat());
  const isMobile = screen?.width < 600 ? true : false;

  useEffect(() => {
    setDateRange(getDateFormat());
  }, [startDate, endDate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        !isMobile
      )
        setIsActive(false);
    };
    document.addEventListener("click", handleClickOutside);
  }, [inputRef]);

  return {
    isActive,
    isMobile,
    inputRef,
    dateRange,
    setIsActive,
    setDateRange,
  };
};
export default DateRangeInputLogic;
